
import { defineComponent } from "vue";
import Icons from "../Icon/svg";

export default defineComponent({
	name: "IconButton",
	components: { ...Icons },
	props: {
		type: {
			type: String,
			required: true,
		},
		variant: {
			type: [String, Array],
			default: "",
		},
		hint: {
			type: String,
			default: "",
		},
	},
	computed: {
		modifiers(): string {
			if (typeof this.variant === "string" && this.variant) {
				return "config-button--" + this.variant;
			}
			if (Array.isArray(this.variant)) {
				return this.variant.map((e) => "config-button--" + e).join(" ");
			}
			return "";
		},
	},
});
